export default {
  title: 'Odkryj pełne możliwości naszej aplikacji mobilnej',
  description: 'Oszczędzaj czas, zdobywaj nagrody, otrzymuj powiadomienia o ofertach i nie tylko',
  buttons: {
    download: 'Otwórz aplikację {{name}}',
  },
};
